import { Button } from 'web-library';
import IconWithLabel from 'web-library/stories/atom/IconWithLabel/IconWithLabel';
import { IconName } from 'web-library/stories/atom/Icon/Icon';
import React from 'react';

interface EditButtonProps {
  editHandler: any;
  label: string;
  buttonId?: any;
}

const EditButton = (props: EditButtonProps) => {
  const { editHandler, label, buttonId } = props;

  return (
    (<Button
                                                                                    style={{ padding: 0, minWidth: 0 }}
                                                                                    color="primary"
                                                                                    variant="text"
                                                                                    onClick={editHandler}
                                                                                    size="small"
                                                                                    id={`button-${label.replace(/\s/, '-')}-${buttonId}`}
                                                                                  >
      <IconWithLabel
        iconSize="M"
        iconName={IconName.edit}
        label={label}
        typographyProps={{
          variant: 'h5',
          align: 'left',
        }}
      />
    </Button>)
  );
};

export default EditButton;
